<template>

  <div class="home">
  <pageTop></pageTop>
  <div ref="banner" class="banner content-item-block">
    <div class="video-wrapper">

      <swiper
          :options="swiperOption"
          ref="swiper"
          @mouseover.native="swiperMouseover"
          @mouseout.native="swiperMouseout"
      >
        <swiper-slide v-for="(item, index) in imgList" :key="index">
          <img :src="item.imgSrc" class="bannerImg" />
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination">
      <span
          v-for="(item, index) in imgList"
          :class="['dot', index == swiper.realIndex?'cur':'']"
          :key="index">
      </span>
        </div>
        <div
            :class="['swiper-button-prev', showArrows?'show': '']"
            slot="button-prev"
            @click="slidePrev"
        >
        </div>
        <div
            :class="['swiper-button-next', showArrows?'show': '']"
            slot="button-next"
            @click="slideNext"
        >
        </div>
      </swiper>

    </div>


  </div>
    <div class="product">

      <ul class="product-fullpage-indicator">
        <li
            v-for="(item, index) in products"
            :key="item.id"
            class="product-fullpage-indicator-item"
            :class="{active:activeIndex===index}"
            @click="activeIndex = index"
        >
          <img :src="item.logo" alt />
        </li>
      </ul>
      <transition :duration="duration" :name="transitionName">
        <!-- ... the buttons ... -->
        <div
            :key="activeIndex"
            class="view-wrapper"
            v-if="!loading"
            :style="`backgroundImage:url(${item.cover})`"
        >
          <div class="content">
            <div class="logo">
              <img :src="item.logo" width="100%" height="100%" alt />
            </div>
            <h2>{{ item.title }}</h2>
            <div class="description">{{ item.description }}</div>
            <div class="subDescription">{{ item.subDescription }}</div>
            <div class="link">
              更多信息，请访问：
              <br />
              <span>{{ item.link }}</span>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <Footer ></Footer>

  </div>
</template>
<script>
// @ is an alias to /src
import { watchScrollDirection } from "@/helper/utilities.js";
import Footer from "@/components/footer.vue";
import pageTop from "@/components/pageTop/pageTop";
import home, {getProduct} from "@/api/home";

export default {
  name: "Product",
  components: {pageTop, Footer},
  data() {
    return {
      productLayerVisible: true,
      search: "",
      products: [],
      jobCategories: [],
      campusList: [],
      byteStandards: [],
      byteStandardActiveIndex: 0,
      staffStories: [],
      youngList: [],
      imgList: [
        { imgSrc: 'https://juanxiuhe.oss-cn-beijing.aliyuncs.com/b111ab5e1ac818b86f0379a91d6d9e57.jpg' },
        { imgSrc: 'https://juanxiuhe.oss-cn-beijing.aliyuncs.com/df0edc62dda58b0c109dd7a82e31221f.jpg'  }],
      currentPage: 1,
      swiperOption: {//swiper3
        autoplay: false,
        speed: 300,
        loop: true,
        pagination: {
          el: '.swiper-pagination'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      swiper: '',
      showArrows: false,
      activeIndex: 0,
      transitionName: "",
      scrolling: false,
      duration: 1000,
      loading: false
    };
  },
  watch: {
    activeIndex(newIndex, oldIndex) {
      if (this.scrolling) {
        return;
      }
      if (this.$route.params.id) {
        delete this.$route.params.id;
        return;
      }

      this.transitionName = newIndex < oldIndex ? "move-down" : "move-up";
    }
  },
  created() {
    home.getProduct({orderBy:"createTime"}).then(rs => {
      this.products = rs.data
    })
  },
  mounted() {
    this.swiper = this.$refs.swiper.swiperInstance;
    const intervalId = setInterval(this.slideNext, 2000);

    home.getProduct({orderBy:"createTime"}).then(rs => {
      this.products = rs.data
    })
    window.addEventListener("mousewheel", this.mousewheelHandler);
  },
  destroyed() {
    window.removeEventListener("mousewheel", this.mousewheelHandler);
  },
  computed: {
    item() {
      return this.products[this.activeIndex] || {};
    }
  },
  methods: {
    mousewheelHandler(e) {
      if (this.scrolling) {
        return;
      }
      this.scrolling = true;
      if (e.wheelDelta > 0) {
        this.transitionName = "move-down";
        this.activeIndex =
          this.activeIndex === 0
            ? this.products.length - 1
            : this.activeIndex - 1;
      } else {
        this.transitionName = "move-up";
        this.activeIndex = (this.activeIndex + 1) % this.products.length;
      }
      setTimeout(() => {
        this.scrolling = false;
      }, this.duration);
    },
    truncatedString(str){
      return str.split('。')
    },
    swiperMouseover() {
      this.showArrows = true;
    },
    swiperMouseout() {
      this.showArrows = false;
    },
    slidePrev() {
      this.swiper.slidePrev();
    },
    slideNext() {
      this.swiper.slideNext();
    },

  }
};
</script>
<style lang="less" scoped>
.move-up-leave-active,
.move-up-enter-active,
.move-down-leave-active,
.move-down-enter-active {
  transition: all 0.7s;
  transition-timing-function: cubic-bezier(0.66, 0, 0.34, 1);
}
.move-up-leave-to,
.move-up-enter,
.move-down-leave-to,
.move-down-enter {
  opacity: 0;
}

.move-up-leave-to,
.move-down-enter {
  transform: translateY(-100%);
}
.move-down-leave-to,
.move-up-enter {
  transform: translateY(100%);
}

.product {
  position: fixed;
  z-index: -1;
  top: 255px;
  right: 0;
  left: 0;
  bottom: 0;
  &-fullpage-indicator {
    position: absolute;
    z-index: 333;
    right: 50px;
    top: 50%;
    transform: translateY(-50%);
    width: 100px;
    &-item {
      margin: 22px 0;
      width: 40px;
      height: 40px;
      cursor: pointer;
      transition: all 0.3s;
      border-radius: 50%;
      overflow: hidden;

      &:hover,
      &.active {
        transform: scale(1.3);

        box-shadow: 0 0 14px 0 @box-shadow-dark-color;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .view-wrapper {
    background-repeat: no-repeat;
    background-size: 100%;
    position: absolute;
    height: 100vh;
    width: 100%;
    padding-top: 100px;
    padding-left: 100px;

    .content {
      width: 300px;
      // text-align: center;
      .logo {
        width: 40px;
        height: 40px;
      }
      h2 {
        margin: 30px 0;
      }
      .description,
      .subDescription {
        color: #aaa;
        line-height: 1.4;
      }
      .link {
        margin-top: 40px;
        span {
          color: @main-color;
        }
      }
    }
  }
}
</style>
